// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"css_mainContainer__sjP9P","privacyPolicyText":"css_privacyPolicyText__G5xV2","alpha":"css_alpha__dtD6T"};